var exports = {
  "container": "x43cbe9c2--c2cd9a--container",
  "compact-top": "x43cbe9c2--c2cd9a--compact-top",
  "title": "x43cbe9c2--c2cd9a--title",
  "phone": "x43cbe9c2--c2cd9a--phone",
};

module.exports = exports;
